export interface Location {
  systemCheck: string;
  examSystemCheck: string;
}

export const Locations: Location = {
  systemCheck: '/system-check',
  examSystemCheck: '/exam-system-check'
};